import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { material, PegarDados2 } from "../../services/api";

const Material_escolar = (props) => {

    let data_inicio = props.di;
    let data_fim = props.df;


    const [data2, setData2] = useState([]);
    const [data3, setData3] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    const fetchData = async () => {
        try {
            const response = await material();
            setData2(response);
            const response3 = await PegarDados2(data_inicio, data_fim);
            setData3(response3.data);
        } catch (error) {
            console.error(error);
        }
    };

    console.log("data2", data2);

    useEffect(() => {
        console.log("B")
        fetchData();
    }, [data_inicio, data_fim]);

    const transpose = (matrix) => {
        return matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex]));
    };

    let chartDataME = [];

    if (typeof data2 !== 'undefined') {
        chartDataME = data2.map((item, index) => {
            const row = [unidades[parseInt(item.ID)]];
            row.push(item.N_Matricula || 0);

            return row;
        });
    };

    chartDataME.sort();
    chartDataME.unshift(['Unidade', 'Compras']);

    const chartDataMET = transpose(chartDataME);

    let dataTA = []

    console.log("data3", data3)

    if (typeof data3 !== 'undefined') {
        dataTA = data3.map((item, index) => {
            const row = [item[0]]
            row.push(item[1])
            return row;

        });
    };
    console.log("dataTA", dataTA);

    dataTA.sort();
    dataTA.pop();
    dataTA.unshift(['Unidade', 'Matriculas']);

    const dataTAT = transpose(dataTA);

    dataTAT.shift();

    console.log("dataTAT", dataTAT)

    chartDataMET.push(dataTAT[0]);

    const dataFinal = transpose(chartDataMET);

    return (
        <div className="media">
            <Chart
                chartType="Table"
                version="current"
                width="100%"
                data={dataFinal}
            />
        </div>
    );
};
export default Material_escolar;